import * as at from "../action-types";

const initialState = "0";

export default (state = initialState, action) => {
  switch (action.type) {
    case at.SET_ACTIVE_TAB:
      return action.payload.active_tab;
    default:
      return state;
  }
};
